// src/App.tsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Navbar from './components/common/Navbar';
import AppRoutes from './routes/AppRoutes';
import { LanguageProvider } from './contexts/LanguageContext';
import { useAuthInit } from './hooks/useAuthInit';
import LoadingState from './components/common/LoadingState';

const App: React.FC = () => {
  const initializing = useAuthInit();

  if (initializing) {
    return <LoadingState message="Loading application..." size="large" />;
  }

  return (
    <LanguageProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-destiny-dark">
          <Navbar />
          <main className="flex-grow container mx-auto px-4 py-8">
            <AppRoutes />
          </main>
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;